import { UiSpinnerProps } from './types';

export const uiSpinnerClassNames = {
  get root() {
    return 'ui-spinner';
  },

  size(size: UiSpinnerProps['size']): string {
    return `${this.root}--size-${size}`;
  },
};
